import React from 'react';
import PropTypes from 'prop-types';
import usePageNavigation from '../../hooks/usePageNavigation';
import { StyledSideNav, NavLink } from './styled';

const SideNav = ({ questions, scrollOffset = 0, color, ...props }) => {
  const { activeLinkIndex, createClickHandler } = usePageNavigation(
    questions,
    scrollOffset
  );

  return (
    <StyledSideNav {...props}>
      {questions.map((question, i) => (
        <NavLink
          key={question.sys?.id}
          href={`#${question.sys?.id}`}
          $active={i === activeLinkIndex}
          $color={color}
          onClick={createClickHandler(`question-${question.sys?.id}`)}
        >
          {question.fields.question}
        </NavLink>
      ))}
    </StyledSideNav>
  );
};

SideNav.propTypes = {
  questions: PropTypes.array.isRequired,
  className: PropTypes.string,
  scrollOffset: PropTypes.number,
  color: PropTypes.string
};

export default SideNav;
